import { List, ListSubheader, TextField, makeStyles } from "@material-ui/core";

import React from "react";
import { useTranslation } from "react-i18next";
import useDatatype from "src/hooks/useDatatype";
import { Theme } from "src/theme";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    color: theme.palette.primary.main,
  },
  select: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    width: "100%",
  },
  button: {
    flex: 1,
  },
}));

export const ContextSelector = () => {
  const { t } = useTranslation();
  const { datatype, contextInfos, setDatatype } = useDatatype();
  const classes = useStyles();

  return (
    <List
      key={"contexts"}
      className={classes.root}
      subheader={
        <ListSubheader
          className={classes.subheader}
          disableGutters
          disableSticky
        >
          {t("views.upload.environment")}
        </ListSubheader>
      }
    >
      <TextField
        // label={"Datatype"}
        select
        size="small"
        className={classes.select}
        SelectProps={{ native: true }}
        value={datatype?.id}
        onChange={(e) => setDatatype(e.target.value)}
        variant="outlined"
      >
        {contextInfos?.map((option) => (
          <option key={option.id} value={option.id}>
            {option.displayName}
          </option>
        ))}
      </TextField>

      {/* <ButtonGroup color="primary" style={{ width: "100%" }}>
        <Button
          onClick={() => setEnvironment("dev")}
          className={classes.button}
          variant={env === "dev" ? "contained" : "outlined"}
        >
          Dev
        </Button>
        <Button
          onClick={() => setEnvironment("test")}
          className={classes.button}
          variant={env === "test" ? "contained" : "outlined"}
        >
          Test
        </Button>
        <Button
          onClick={() => setEnvironment("prod")}
          className={classes.button}
          variant={env === "prod" ? "contained" : "outlined"}
        >
          Prod
        </Button>
      </ButtonGroup> */}
    </List>
  );
};
